import type { Event, GameEngine } from '@/types/EntityTypes';
import type { GameState } from '@/types';

export class EventEntity implements Event {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public probability: number,
    public duration: number,
    public condition: (gameState: GameState) => boolean,
    public effect: (game: GameEngine) => void,
  ) {}

  canOccur(_gameState: GameState): boolean {
    return false;
  }

  execute(gameEngine: GameEngine): void {
    if (this.effect && typeof this.effect === 'function') {
      this.effect(gameEngine);
    }
  }

  getDisplayText(): string {
    return `${this.name}: ${this.description}`;
  }

  /**
   * Static method to filter possible events based on game state
   */
  static getPossibleEvents(events: EventEntity[], gameState: GameState): EventEntity[] {
    return events.filter(event => event.canOccur(gameState));
  }
} 